export default __webpack_public_path__ + "static/Evisort-a602ff9813a31a608350e516d6fbc2ca.pdf";